<script lang="ts">
	import { format, locale } from 'svelte-i18n';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { profile_data, user_data } from 'src/stores/account/user';
	import { navigateToShop } from '../Lists/list-helpers';
	import { ButtonV2 } from '@Shelly/shelly-design-system';
	import { getPromoExpiryText } from 'src/helpers/promo_helpers';
	import { PROMOTIONS } from 'src/constants';

	import PromoModal from 'src/components/Promotions/organisms/PromoModal.svelte';
	import PromoModalBanner from 'src/components/Promotions/molecules/PromoModalBanner.svelte';
	import { capFirstChar } from 'src/helpers/utilities';
	import { createEventDispatcher } from 'svelte';

	export let showModal = false;

	const dispatch = createEventDispatcher();

	const onCloseModal = (fromJoinButton = false) => {
		if (showModal) {
			showModal = false;
			if (!$profile_data?.promotions?.smartHomeChallenge2026) {
				save_profile('promotions', {
					...$profile_data?.promotions,
					smartHomeChallenge2026: new Date().getTime(),
				});
			}
			if (!fromJoinButton) {
				const shc26 = { ...$profile_data?.aep?.shc26 };
				shc26.closeOnPromotionModal = (shc26?.closeOnPromotionModal || 0) + 1;
				save_profile('aep', { ...$profile_data.aep, shc26 });
			}
			dispatch('close');
		}
	};

	const handleSaveForLater = () => {
		onCloseModal();
	};

	const handleJoinNow = () => {
		onCloseModal(true);
		const shc26 = { ...$profile_data?.aep?.shc26 };
		shc26.clickOnJoinNowButton = (shc26?.clickOnJoinNowButton || 0) + 1;
		save_profile('aep', { ...$profile_data.aep, shc26 });
		const utm = 'utm_source=pop-up&utm_medium=app&utm_campaign=challenge-2026';
		if ($user_data?.timezone?.startsWith('America/')) {
			navigateToShop(`https://us.shelly.com/pages/shelly-smart-home-challenge-2026?${utm}`);
		} else {
			navigateToShop(
				`https://www.shelly.com/${['de', 'fr', 'it'].includes($locale) ? `${$locale}/` : ''}pages/shelly-smart-home-challenge-2026?${utm}`,
			);
		}
	};

	$: expiryText = $format(
		getPromoExpiryText(PROMOTIONS.SMART_HOME_CHALLENGE_2026.END_DATE)?.key,
		getPromoExpiryText(PROMOTIONS.SMART_HOME_CHALLENGE_2026.END_DATE)?.object,
	);

	$: image = $user_data?.timezone?.startsWith('America/')
		? './images/ioT-Challenge-us.png'
		: `./images/ioT-Challenge-${['de', 'fr', 'it'].includes($locale) ? $locale : 'default'}.png`;
</script>

<PromoModal
	{showModal}
	title={$format('title_smart_home_challenge_2026', { default: 'Smart Home Challenge 2026' })}
	closeAriaLabel={$format('button_close', { default: 'Close' })}
	on:close={handleSaveForLater}
	backdropClose
>
	<PromoModalBanner
		{image}
		alt={$format('title_smart_home_challenge_2026', { default: 'Smart Home Challenge 2026' })}
		activeBadgeLabel={$format('label_active', { default: 'Active' })}
		aspectRatio="1200 / 800"
		overlayPosition="top"
		{expiryText}
	/>

	<div class="content-section">
		<div class="content-text">
			<p class="content-paragraph text-bold">
				{$format('heading_smart_home_challenge_2026', {
					default: 'Join The Shelly Smart Home Challenge 2026',
				})}
			</p>
			<p class="content-paragraph text-300">
				{$format('text_smart_home_challenge_2026_intro', {
					default:
						"Ready to show off your smart Shelly setup? We've got 3 new categories in this challenge. Check them out and shine bright!",
				})}
			</p>
			<p class="content-paragraph text-300">
				{$format('text_smart_home_challenge_2026_dates', {
					default: 'Submit your entry from May 18th til June 3rd.',
				})}
			</p>
		</div>
	</div>

	<svelte:fragment slot="footer">
		<div class="width-full d-flex justify-content-end gap-s">
			<ButtonV2
				variant="secondary"
				on:click={handleSaveForLater}
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			>
				{capFirstChar($format('button_maybe_later', { default: 'Maybe later' }))}
			</ButtonV2>
			<ButtonV2
				variant="primary"
				on:click={handleJoinNow}
				icon="fas fa-trophy-star"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			>
				{$format('button_join_now', { default: 'Join now' })}
			</ButtonV2>
		</div>
	</svelte:fragment>
</PromoModal>

<style>
	.content-section {
		display: flex;
		flex-direction: column;
		gap: 24px;
		padding: 24px 24px 0px 24px;
	}

	.content-text {
		font-family: 'Inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 19px;
		color: var(--color-white, #ffffff);
	}

	.content-paragraph {
		margin: 0 0 10px 0;
	}

	@media (max-width: 639px) {
		.content-section {
			padding: 16px 16px 0px 16px;
		}
	}
</style>
